import {ChronoUnit} from "@js-joda/core";
import validateUnitValue from "components/basic/dropdowns/time-unit-dropdown/time-unit-utils";
import React from "react";
import {TIME_UNITS} from "components/basic/dropdowns/time-unit-dropdown/timeUnits";
import {Dropdown, DropdownChangeParams} from "primereact/dropdown";
import {T} from "services/lang/LanguageService";

interface ITimeUnitDropdownProps {
    id?: string;
    className?: string;
    value: ChronoUnit | string;
    onChange: (e: DropdownChangeParams) => void;
    disabledValue?: ChronoUnit,
    options?: any
}

const TimeUnitDropdown = ({value, onChange, className, id, disabledValue, options}: ITimeUnitDropdownProps) => {
    return (
        <Dropdown
            id={id}
            className={className}
            placeholder={T("word.units")}
            value={validateUnitValue(value)}
            onChange={onChange}
            optionDisabled={(option) => {
                return option.value === disabledValue
            }}
            options={options ?? TIME_UNITS}/>
    )
}

export default TimeUnitDropdown;